import isClient from "./isClient";

const hasLocalStorage: () => boolean = () =>
  isClient() && typeof window.localStorage !== "undefined" && window.localStorage !== null;

export default hasLocalStorage;
